var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "800px",
    viewBox: "-3 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview",
    transform: "translate(-183.000000, -5399.000000)",
    fill: "#004AAD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(56.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137,5246.635 C137,5244.978 135.657,5243.635 134,5243.635 C132.343,5243.635 131,5244.978 131,5246.635 C131,5248.292 132.343,5249.635 134,5249.635 C135.657,5249.635 137,5248.292 137,5246.635 M141,5246 C141,5249.866 134,5259 134,5259 C134,5259 127,5249.866 127,5246 C127,5242.134 130.134,5239 134,5239 C137.866,5239 141,5242.134 141,5246 M135,5246.635 C135,5247.186 134.551,5247.635 134,5247.635 C133.449,5247.635 133,5247.186 133,5246.635 C133,5246.084 133.449,5245.635 134,5245.635 C134.551,5245.635 135,5246.084 135,5246.635",
    id: "pin_fill_sharp_circle-[#635]"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pinIcon.29abcd82e25a7a36c93b4244f64d29e3.svg";
export { ForwardRef as ReactComponent };